import React from "react";
import {I18n} from "../../../../models/I18n";
import ListSummary from "../ListSummary/ListSummary";
import style from "./style/PersonalitySummary.module.scss";
import {ReportSummaryColors} from "../../constants/ReportSummaryColors";

export enum ScaleType {
    MAIN = "main",
    SUB = "sub",
}

export interface PersonalitySummaryProps {
    title: string;
    handle: string;
    basedOn: string;
    scores: any[];
    scrollToSection?: (elementId: string) => void;
    circleColor?: ReportSummaryColors;
    i18n: I18n;
    classes?: { titleDecoration: string; }
}

const PersonalitySummary = ({ title, handle, basedOn, scores, scrollToSection, i18n, classes, circleColor }: PersonalitySummaryProps) => {
    const mainScores = scores.filter((score) => score.scaleType === ScaleType.MAIN);

    const getLabel = (score) => {
        // BE returns "high", "average" and "low" as evaluation and labels are either "high", "middle" or "low".
        const evaluation =
            score.evaluationSummary?.evaluation === "average" ? "middle" : score.evaluationSummary?.evaluation;

        return score[`${evaluation}Label`];
    };

    return (
        <div className={style.personalitySummaryWrapper}>
            <ListSummary
                basedOn={basedOn}
                circleColor={circleColor || ReportSummaryColors.LIGHTBLUE}
                handle={handle}
                i18n={i18n}
                scrollToSection={scrollToSection ? scrollToSection : null}
                showViewAll={!!scrollToSection}
                title={title}
                classes={ classes || { titleDecoration: "" } }
            >
                <ul>
                    {mainScores.map((mainScore) => (
                        <li key={mainScore.handle} data-testid="personality-score">
                            <h5>{getLabel(mainScore)}</h5>
                            <p>{mainScore.evaluationSummary?.definition}</p>
                        </li>
                    ))}
                </ul>
            </ListSummary>
        </div>
    );
};

export default PersonalitySummary;
